export const serviceMenuTranslationJP = {
  serviceMenu: {
    title: 'サービスメニュー編集',
    description: '※並び順の変更について',
    description_1: 'メニューを選択して、キーボード操作で並び順を変更することができます。',
    button: {
      add: '追加',
      delete: '削除',
      save: '保存',
    },
    warn_confirm_delete:
      '選択されたサービスをリストから削除します。削除したサービスはメニュー詳細のサービスプロパティを無効にします。よろしいですか？',
    success_delete: 'データを削除しました',
    success_restore: '削除データを復元しました。',
    success_save: '保存しました',
    no_data_changed: 'データは変更されていません',
  },
  ServiceMenuListPage: {
    choice: '選択',
    menu_cd: 'メニューコード',
    menu_name: 'メニュー名',
    restore: '復元',
  },
};
